"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addBkVgmWeb = addBkVgmWeb;
exports.delObj = delObj;
exports.downloadFile = downloadFile;
exports.getDocBasicConfig = getDocBasicConfig;
exports.getVVLInfo = getVVLInfo;
exports.getVgmByContainers = getVgmByContainers;
exports.getVgmInfo = getVgmInfo;
exports.searchVVL = searchVVL;
exports.vgmApplyQuery = vgmApplyQuery;
exports.vgmInfoQuery = vgmInfoQuery;
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _request = _interopRequireDefault(require("@/utils/request"));
var _validate = require("@/utils/validate");
/**
 * 箱净重查询
 * @param query
 */
function getVgmByContainers(query) {
  return (0, _request.default)({
    url: '/equery/ecmVgmInfoWeight/getVgmByContainers',
    method: 'post',
    params: query
  });
}

/**
 * 目前没用上
 * @param VGM  信息查询
 */
function vgmInfoQuery(query) {
  return (0, _request.default)({
    url: '/doc/vgm/vgmSearchEc',
    method: 'post',
    params: query
  });
}

/**
 *
 * @param query
 */
function vgmApplyQuery(query) {
  return (0, _request.default)({
    url: '/equery/vgm/searchDeclareEC',
    method: 'post',
    params: query
  });
}

/**
 *
 * @param bkVgmContainerWebId
 */
function getVgmInfo(id) {
  return (0, _request.default)({
    url: '/ebusiness/webBkVgmContainer/getById/' + id,
    method: 'get'
  });
}

/**
 *
 * @param obj
 */
function addBkVgmWeb(obj) {
  return (0, _request.default)({
    url: '/ebusiness/webBkVgmContainer/addBkVgmWeb',
    method: 'post',
    data: obj
  });
}

/**
 *
 * @param id
 */
function delObj(id) {
  return (0, _request.default)({
    url: '/ebusiness/webBkVgmContainer/delete/' + id,
    method: 'get'
  });
}

/**
 *
 * @param query
 */
function getVVLInfo(query) {
  return (0, _request.default)({
    url: '/equery/vgm/getVVLPage',
    method: 'post',
    params: query
  });
}

/**
 *
 * @param query
 */
function getDocBasicConfig(query) {
  return (0, _request.default)({
    url: '/equery/docBasicConfig/queryList',
    method: 'get',
    params: query
  });
}

/**
 * pdf,png可以直接预览,前提是bucket已开放，未开放则不能使用改接口
 * 其他文件类型，下载
 * @param minioName 数据库文件名称
 * @param fileName 下载文件名称
 * @returns {*}
 */
function downloadFile(minioName, fileName) {
  var fileType = minioName.substr(minioName.lastIndexOf('.') + 1, minioName.length);
  // pdf,png可以直接预览
  if (fileType === 'pdf' || 'jpeg,jpg,png'.includes(fileType)) {
    var bucket = minioName.substr(0, minioName.indexOf('-'));
    var href = this.GLOBAL.MINIO_IP + bucket + '/' + minioName.substr(minioName.indexOf('-') + 1, minioName.length);
    window.open(href);
  } else {
    return (0, _validate.validateNull)(minioName) ? null : (0, _request.default)({
      url: 'ebusiness/webBkVgmContainer/downloadFileByName/' + minioName,
      method: 'get',
      responseType: 'blob'
    }).then(function (response) {
      // 处理返回的文件流

      //console.log(response)
      var blob = new Blob([response], {
        type: "application/octet-stream;chartset=UTF-8"
      });
      //let blob = response

      // console.log(blob)

      // 设置下载链接
      var url = URL.createObjectURL(blob);
      var x = new XMLHttpRequest();
      // 用于创建 HTTP 请求，但请求并未发送。
      x.open('GET', url, true);
      x.responseType = 'blob';
      x.onload = function (e) {
        var url = window.URL.createObjectURL(x.response);
        var a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        a.click();
      };
      // 实际发出 HTTP 请求
      x.send();
    });
  }
}
function searchVVL(query) {
  return (0, _request.default)({
    url: 'ebusiness/webBkVgmContainer/searchVesselNameByBlNo',
    method: 'post',
    params: query
  });
}